// src/config/permissions.js
const rolePermissions = {
    0: [
        '/capacity/capManage',
        '/overview',
        '/problemGraph/probManage',
        '/capacity/capOntology',
        '/capacity/capInstance',
        '/manage/ontology',
        '/manage/instance',
        '/problemGraph/probOntology',
        '/problemGraph/probInstance',
        '/capacity/capGraph',
        '/relation/conceptmap',
        '/relation/knowledgedisplay',
        '/problemGraph/graph',
        '/bigScreen',
        '/project',
        '/login',
        '/loginOLD',
        '/kgBase/index',
        '/kgBase/cardList',
        '/manage/studentManage'
    ],
    1: [
        '/capacity/capManage',
        '/overview',
        '/problemGraph/probManage',
        '/capacity/capGraph',
        '/relation/conceptmap',
        '/relation/knowledgedisplay',
        '/problemGraph/graph',
        '/bigScreen',
        '/project',
        '/login',
        '/loginOLD',
        '/kgBase/index',
        '/kgBase/cardList',
        '/manage/studentManage'
    ],
    2: [
        // '/bigScreen',
        '/stu_project',
        '/login',
        '/loginOLD',
        '/capacity/stuCapManage',
        '/manage/stuOverview',
        '/relation/stu_coneptmap',
        '/relation/stu_knowledgedisplay',
        '/problemGraph/stuProbManage', 
        '/ques/index',
        '/ques/result'
    ],
  };
  
  export default rolePermissions;

  